import React from 'react';

const ANSWER_STATUS_META = [
  { key: 'accepted', color: '#10B981', label: 'Akzeptiert' },
  { key: 'review', color: '#F59E0B', label: 'Weitere Prüfung' },
  { key: 'missing', color: '#F97316', label: 'Information fehlt' },
  { key: 'rejected', color: '#EF4444', label: 'Abgelehnt' },
];

const AnswerStatusBadges = ({ statuses = [], size = 'sm' }) => {
  const counts = ANSWER_STATUS_META.reduce((acc, meta) => {
    acc[meta.key] = 0;
    return acc;
  }, {});

  (statuses || []).forEach(s => {
    if (s && s.answer_status && counts.hasOwnProperty(s.answer_status)) {
      counts[s.answer_status] += 1;
    }
  });

  const padding = size === 'xs' ? 'px-1.5 py-0.5 text-[11px]' : 'px-2 py-0.5 text-[12px]';
  const dotSize = size === 'xs' ? 'w-1.5 h-1.5' : 'w-2 h-2';

  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {ANSWER_STATUS_META.map(meta => {
        const count = counts[meta.key];
        const isZero = count === 0;
        return (
          <span
            key={meta.key}
            title={`${meta.label}: ${count}`}
            className={`inline-flex items-center gap-1 rounded-full font-medium ${padding} ${isZero ? 'bg-[#F3F4F6] text-[#9CA3AF]' : 'text-white'}`}
            style={isZero ? undefined : { backgroundColor: meta.color }}
          >
            <span
              className={`inline-block rounded-full ${dotSize}`}
              style={{ backgroundColor: isZero ? '#D1D5DB' : '#ffffff' }}
            />
            {count}
          </span>
        );
      })}
    </div>
  );
};

export default AnswerStatusBadges;
